import { useEffect } from 'react'

export default function SEO({ title, description, isHome = false }) {
  useEffect(() => {
    // Exact format required by user:
    // Forside: Havdrup Rengøring
    // Undersider: [Titel på underside] - Havdrup Rengøring
    const fullTitle = isHome ? 'Havdrup Rengøring' : `${title} - Havdrup Rengøring`
    document.title = fullTitle

    const defaultDesc =
      'Havdrup Rengøring tilbyder fleksibel rengøring til private, virksomheder og klinikker. Kontakt os for en løsning og et tilbud tilpasset din opgave.'
    const metaDesc = description || defaultDesc

    let metaTag = document.querySelector('meta[name="description"]')
    if (!metaTag) {
      metaTag = document.createElement('meta')
      metaTag.name = 'description'
      document.head.appendChild(metaTag)
    }
    metaTag.setAttribute('content', metaDesc)

    // OpenGraph title & desc
    let ogTitle = document.querySelector('meta[property="og:title"]')
    if (!ogTitle) {
      ogTitle = document.createElement('meta')
      ogTitle.setAttribute('property', 'og:title')
      document.head.appendChild(ogTitle)
    }
    ogTitle.setAttribute('content', fullTitle)

    let ogDesc = document.querySelector('meta[property="og:description"]')
    if (!ogDesc) {
      ogDesc = document.createElement('meta')
      ogDesc.setAttribute('property', 'og:description')
      document.head.appendChild(ogDesc)
    }
    ogDesc.setAttribute('content', metaDesc)
  }, [title, description, isHome])

  return null
}
